import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import VariableSalaryModalBase from "../VariableSalaryModalBase.vue";
import priceFormatter from "@/utility/priceFormatter";
import Absence from "../Absence.vue";
import TeamManagerCalculationBasis from "./TeamManagerCalculationBasis.vue";
import TeamManagerCalculationEquaction from "./TeamManagerCalculationEquaction.vue";
import TeamManagerEmployeeDetails from "./TeamManagerEmployeeDetails.vue";
export default Vue.extend({
    props: {
        salaryRow: {},
        salaryRowDetails: {},
    },
    components: {
        VariableSalaryModalBase,
        TeamManagerCalculationBasis,
        TeamManagerCalculationEquaction,
        TeamManagerEmployeeDetails,
        Absence,
    },
    filters: {
        numberToSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK();
        },
    },
    computed: {
        ...mapGetters("variableSalaryModal", ["hoveredVariable"]),
        variableSalaryClass() {
            const base = ["math-text", "h1", "cursor-default"];
            if (this.hoveredVariable === "Variable salary") {
                base.push("hovered");
            }
            return base;
        },
    },
    methods: {
        ...mapActions("variableSalaryModal", ["setHoveredVariable"]),
        hoveredClass(target) {
            if (target === this.hoveredVariable) {
                return "hovered";
            }
        },
    },
});
